import React, { FC } from 'react';
import {
  getProductionBatchByProductionOperationId,
  getProductionBatchByProductionOrderId,
  operationsSearch,
  productionOrdersSearch,
} from '../../../../../../reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { connect } from 'react-redux';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { NCFileSearchItem } from '@interfaces/search';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useJobDetails } from '@v2/pages/common/hooks/useJobDetails';
import { getNCFilesByProductionOperationId, getNCFilesByProductionOrderId } from '@reducers/manufacture';
import NCFileListOrSingleItem from '@v2/pages/machines/modules/now/components/NC-file/components/NCFileListOrSingleItem';
import { ProductionOrderScreenProps } from '@v2/pages/productionOrder/common/interfaces';
import { loadSingleBatch } from '@reducers/batch';
import { useProductionOrderDetails } from '@v2/pages/common/hooks/useProductionOrderDetails';

interface ProductionOrderDetailsNCFileProps extends ProductionOrderScreenProps {
  ncFiles: ReducerEntityWithLoadingState<NCFileSearchItem[]>;
  ncFileId: number | null;
}

const ProductionOrderDetailsNCFileComponent: FC<ProductionOrderDetailsNCFileProps> = ({
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
  productionOrdersSearch,
  ncFiles,
  ncFileId,
}) => {
  const title = useTitle();

  const { ncFileDataLoading } = useProductionOrderDetails({
    productionOrdersSearch,
    getNCFilesByProductionOrderId,
    getProductionBatchByProductionOrderId,
    loadSingleBatch,
    updateHeaderConfig,
    getAllNcFiles: true,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <NCFileListOrSingleItem
        ncFileData={ncFiles.data}
        ncFileDataLoading={!ncFiles.wasLoaded}
        ncFileId={ncFileId}
        ncFileDataLoadingForList={ncFileDataLoading}
      />
    </DetailsPageWrapper>
  );
};

const ProductionOrderDetailsNCFile = connect(({ details: { ncFiles, ncFileId } }) => ({ ncFiles, ncFileId }), {
  productionOrdersSearch,
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
})(ProductionOrderDetailsNCFileComponent);

export { ProductionOrderDetailsNCFile };
